import { render } from "./bundle-gallery-image.vue?vue&type=template&id=1700b7e0"
import script from "./bundle-gallery-image.vue?vue&type=script&lang=js"
export * from "./bundle-gallery-image.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/.worktrees/pdp-packs/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__